import { makeStyles } from '@material-ui/styles'
import Text from 'pf9-ui-components/built/elements/Text'
import React from 'react'
import Theme from 'core/themes/model'

const useGPUTagStyles = makeStyles((theme: Theme) => ({
  tagContainer: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  tag: {
    width: 'max-content',
    border: `1px solid ${theme.palette.blue[700]}`,
    color: theme.palette.blue[700],
    backgroundColor: theme.palette.blue[100],
    padding: theme.spacing(0, 0.5),
    borderRadius: theme.spacing(0.5),
  },
}))

const GPUFlavorTag = ({ children }) => {
  const classes = useGPUTagStyles()
  return (
    <div className={classes.tagContainer}>
      {children}
      <Text className={classes.tag} variant="caption2">
        GPU
      </Text>
    </div>
  )
}

export default GPUFlavorTag

export const GPUFlavorTagCellComponent = ({ value, item }) => {
  return item?.gpuFlavor ? (
    <GPUFlavorTag>
      <Text variant="body2">{value}</Text>
    </GPUFlavorTag>
  ) : (
    <Text variant="body2">{value}</Text>
  )
}
